export default __webpack_public_path__ + "static/media/rojon_resume.3fcc347b.pdf";